module.exports = __webpack_public_path__ + "static/media/IconTemplates_-38.18157848.svg";